import { render, staticRenderFns } from "./FooterMobileNav.vue?vue&type=template&id=106fe420&scoped=true"
import script from "./FooterMobileNav.vue?vue&type=script&lang=js"
export * from "./FooterMobileNav.vue?vue&type=script&lang=js"
import style0 from "./FooterMobileNav.vue?vue&type=style&index=0&id=106fe420&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "106fe420",
  null
  
)

export default component.exports